// The system a ticket was raised from. Mirrors EscalationPlatform on the backend: tickets with no
// platform (everything raised before it existed) are Proship's.
export const PLATFORM_META = {
    PROSHIP: { label: "Proship", longLabel: "Proship Tickets" },
    WMS: { label: "WMS", longLabel: "WMS Tickets" },
    CT: { label: "CT", longLabel: "Control Tower Tickets" },
};
export const PLATFORMS = ["PROSHIP", "WMS", "CT"];
/** The Tickets page's tabs: every platform, then each one. */
export const PLATFORM_TABS = [{ key: "ALL", longLabel: "All Tickets" }, ...PLATFORMS.map((key) => ({ key, longLabel: PLATFORM_META[key].longLabel }))];
export const PLATFORM_OPTIONS = PLATFORMS.map((value) => ({ value, label: PLATFORM_META[value].label }));
export const platformOf = (row) => row?.platform || "PROSHIP";
